"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const styling_1 = require("../../styling");
const utils_1 = require("../../styling/utils");
const Close_1 = tslib_1.__importDefault(require("../Buttons/Close"));
const styles_1 = tslib_1.__importDefault(require("./styles"));
function SlidingShelf({ className = "", classes = { root: {} }, onCloseButtonClick, open, children, variant = "light", height, style, ...rest }) {
    const mergedClasses = (0, styling_1.useStyles)({ source: classes, target: styles_1.default }, "slidingShelf");
    const mergedStyles = (0, utils_1.mergeStylesObjects)(classes, styles_1.default);
    return (react_1.default.createElement("div", { className: `${mergedClasses.root} ${variant === "dark" && "dark-shelf"} ${open && "open"} ${className}`, ...rest },
        react_1.default.createElement(Close_1.default, { onClick: onCloseButtonClick, open: open, classes: { root: mergedStyles.closeButton } }),
        children));
}
exports.default = SlidingShelf;
//# sourceMappingURL=index.js.map